export const formatNumber = (value: number | string | boolean) => {
    let valueToFormat = value;

    if (typeof value === "number") {
        valueToFormat = Number(value).toFixed(2);
    }

    return valueToFormat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    
}